import styled from "styled-components";

export const JiraWorklogsWrapper = styled.div`
  grid-column: span 2;
  display: grid;
  grid-template-columns: minmax(0, 385px) 1fr;
  gap: 10px;
  padding: 10px;
  max-height: 100%; 
  overflow: hidden; 
  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
  }
}
`;

export const DataWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  gap: 10px;
  overflow: hidden; 


  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-template-columns: 1fr;
  }
`;
